// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-components-Icon----icon-module---icon---3TWyF","small":"src-components-Icon----icon-module---small---2l7hP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/icon.module.scss
// module id = 302
// module chunks = 168707334958949